import { render } from "./MoreDetailsRoster23View.vue?vue&type=template&id=4109deea&scoped=true"
import script from "./MoreDetailsRoster23View.vue?vue&type=script&lang=js"
export * from "./MoreDetailsRoster23View.vue?vue&type=script&lang=js"

import "./MoreDetailsRoster23View.vue?vue&type=style&index=0&id=4109deea&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4109deea"]])

export default __exports__